import { createFileRoute, redirect } from '@tanstack/react-router'
import { USERS_SCREEN_PERMISSIONS } from '~/components/routes/users/screens'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * `/users/bo` — ancienne liste des comptes du back-office (DataGrid MUI), **absorbée** par l'axe
 * « Par utilisateur » de `/administration/access` (spec §3.1).
 *
 * La route est conservée en **redirection** plutôt que supprimée : elle est la cible de liens
 * partagés, de favoris et des `navigate({ to: '/users/bo' })` des écrans de création et d'édition
 * d'un compte. Sa garde reste `read users.bo-users.user`, pour ne pas ouvrir une redirection à qui
 * n'avait pas le droit d'ouvrir la liste.
 *
 * La pile MUI du module (`UsersSearchGrid`, `users-page-layout`, `UserRolesCell`) a été retirée
 * avec la refonte Clients (kanban #870).
 */
export const Route = createFileRoute('/_authenticated/users/bo')({
  staticData: {
    permission: USERS_SCREEN_PERMISSIONS.bo,
  },
  beforeLoad: () => {
    throw redirect({ to: '/administration/access' })
  },
})
withRoutePermissions(Route)
